document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 990) {
    document.querySelectorAll('.collection-banner__features-slider').forEach(function(sliderEl) {
      try {
        var splide = new Splide(sliderEl, {
          type: 'slide',
          pagination: true,
          arrows: false,
          drag: true,
          gap: '16px',
          perPage: 1,
          perMove: 1,
          padding: 0,
          trimSpace: true,
          focus: 0,
          pagination: false,
        });

        splide.mount();
      } catch (e) {
        console.error('Collection banner slider error:', e);
      }
    });
  }
});
 
